import React from 'react'
import { useSelector } from 'react-redux'
import { renderContent, subQuestions } from '../../utils/helpers'
import DateInput from '../../widgets/DateInput'
import FullName from '../../widgets/FullName'
import LifeStatusWithDoD from '../../widgets/LifeStatusWithDOD'
import SexAssignedAtBirth from '../../widgets/SexAssignedAtBirth'

const ChildQuestions = ({ personId, config }) => {
  const localization = useSelector(({ localization }) => localization)

  const renderMap = {
    name: (
      <FullName
        key="fn"
        id={personId}
        localization={localization}
        config={subQuestions({ config, key: 'name' })}
      />
    ),
    sexAtBirth: <SexAssignedAtBirth key="sab" id={personId} />,
    dateOfBirth: <DateInput key="dob" id={personId} />,
    lifeStatusWithDod: (
      <LifeStatusWithDoD
        key="lswd"
        personId={personId}
        config={subQuestions({ config, key: 'lifeStatusWithDod' })}
      />
    ),
  }
  const content = []

  renderContent({ renderMap, config, content })

  return <>{content}</>
}

export default ChildQuestions
